<template>
  <HorizontalItemsDivider :items="breadcrumbs" align-items="start">
    <template #default="{ items }">
      <LinkBreadcrumbs
        v-for="(link, idx) in items"
        :key="link.value"
        :to="toLocalePath(link.to)"
        only-exact-active
      >
        {{ link.value }}
        <span
          v-if="showDividerTag(idx, items.length)"
          :key="`span-${link.value}`"
          class="inline-block pl-1.5 pr-2.5 align-middle text-gray-secondary"
        >
          <IconUiArrowRight class="size-2" />
        </span>
      </LinkBreadcrumbs>
    </template>
  </HorizontalItemsDivider>
</template>

<script setup lang="ts">
import type { BreadcrumbItem } from '@scayle/storefront-nuxt'
import type { DividerItem } from '#layers/base/components/ui/dividers/HorizontalItemsDivider.vue'

const i18n = useI18n()
const { toLocalePath } = useRouteHelpers()

const props = defineProps({
  links: {
    type: Array as PropType<BreadcrumbItem[]>,
    required: true,
  },
})

const breadcrumbs = computed(
  () =>
    [
      { to: toLocalePath('/'), value: i18n.t('global.home') },
      ...props.links,
    ] as DividerItem[],
)
</script>
